import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { COOKIE_DOMAIN } from '../login-modal/constants/login-constant';
import { CoreUtilHelperService } from './core-util-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CoreUtilService extends CoreUtilHelperService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Record<string, unknown>
  ) {
    super();
  }

  set(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }

  get(key: string) {
    return window.localStorage.getItem(key);
  }

  remove(key: string) {
    window.localStorage.removeItem(key);
  }

  getCookieValue(cookieName: string) {
    if (isPlatformBrowser(this.platformId)) {
      const result = new RegExp(
        '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
      ).exec(document.cookie);
      return result ? result[1] : null;
    }
    return null;
  }

  deleteCookie(cookieName: string) {
    const date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
    // Set it
    document.cookie =
      cookieName + '=; expires=' + date.toUTCString() + COOKIE_DOMAIN;
  }

  cookieDomain(authenticationConfig: OauthAEMConfig | undefined): string {
    return authenticationConfig?.COOKIE_DOMAIN
      ? authenticationConfig.COOKIE_DOMAIN
      : COOKIE_DOMAIN;
  }

  setCookieName(
    cookieName: string,
    cookieValue: string | boolean | number,
    expireDays: number,
    keepSession: boolean,
    authenticationConfig?: OauthAEMConfig
  ) {
    const cookiesLife = new Date();
    if (expireDays > 0 || keepSession) {
      cookiesLife.setTime(
        cookiesLife.getTime() + expireDays * 24 * 60 * 60 * 1000
      );
    } else {
      cookiesLife.setTime(expireDays);
    }
    const expires = keepSession ? '' : '; expires=' + cookiesLife.toUTCString();
    const cookieDomain = this.cookieDomain(authenticationConfig);
    const cookieDetails =
      cookieName + '=' + cookieValue + expires + cookieDomain;
    document.cookie = cookieDetails;
  }

  getAccountCookie(cookieName: string) {
    const name = cookieName + '=';
    const temp = document.cookie.split(';');
    for (let i = 0; i < temp.length; i++) {
      let ca = temp[i];
      while (ca.charAt(0) === ' ') {
        ca = ca.substring(1);
      }
      if (ca.indexOf(name) === 0) {
        return ca.substring(name.length, ca.length);
      }
    }
    return '';
  }

  updateRefreshUrlCheck(aemrefreshurl: HTMLInputElement | null | undefined) {
    return (
      window.location.pathname.lastIndexOf('/') ===
        window.location.pathname.length - 1 ||
      (aemrefreshurl !== null && aemrefreshurl !== undefined)
    );
  }

  getWindow(): Window {
    if (isPlatformBrowser(this.platformId)) {
      return window;
    }
    return <Window>(<unknown>null);
  }

  checkFromModalQueryParam(): boolean {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const fromModal = urlParams.get('fromModal');

    let makeAuthCall = true;
    if (fromModal) {
      makeAuthCall = false;
    } else {
      makeAuthCall = true;
    }
    return makeAuthCall;
  }

  sendMessage(message: {
    type: string;
    token?: string;
    issueTime?: number;
    expiresIn?: number;
    eamStatus?: string;
  }) {
    return new Promise(function (resolve, reject) {
      const messageChannel = new MessageChannel();
      messageChannel.port1.onmessage = function (event) {
        if (event.data.error) {
          reject(event.data.error);
        } else {
          resolve(event.data);
        }
      };

      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(message, [
          messageChannel.port2
        ]);
      }
    });
  }
}
